'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _victor = require('victor');

var _victor2 = _interopRequireDefault(_victor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Simply extending Victor.
 * This will clobber Victor methods, so potentially dangerous if Victor updates.
 */
var Vector = _victor2.default;

Vector.lineVector = function lineVector(start, end) {
    var endVector = end instanceof _victor2.default ? end.clone() : _victor2.default.fromObject(end);

    return endVector.subtract(start);
};

/**
 * Creates a vector of the same magnitude as this vector but perpendicular to it.
 */
Vector.prototype.perpendicular = function perpendicular() {
    var x = -this.y;
    this.y = this.x;
    this.x = x;
    return this;
};

/**
 * Creates a vector of the same magnitude as this vector but is the right perpendicular to it.
 */
Vector.prototype.perpendicularRight = function perpendicularRight() {
    var x = this.y;
    this.y = -this.x;
    this.x = x;
    return this;
};

/**
 * Makes the vector have a specific length, but remain in the same direction.
 */
Vector.prototype.toLength = function toLength(length) {
    return this.normalize().multiplyScalar(length);
};

/**
 * Returns the magnitude of the projection of the "vector to project" onto this vector.
 * I.e. This is the "adjacent" in the right angle triangle between this vector and other vector.
 */
Vector.prototype.projectedMagnitude = function projectedMagnitude(vectorToProject) {
    return this.dot(vectorToProject) / this.length();
};

/**
 * Returns the ratio of the projection of the "vector to project" onto this vector.
 * I.e. This is the "adjacent" in the right angle triangle between this vector and other vector divided by
 * the length of this vector.
 */
Vector.prototype.projectedRatio = function projectedRatio(vectorToProject) {
    return this.dot(vectorToProject) / Math.pow(this.length(), 2);
};

Vector.prototype.toFixed = function toFixed(precision) {
    var _precision = precision || 8;
    this.x = Number(this.x.toFixed(_precision));
    this.y = Number(this.y.toFixed(_precision));
    return this;
};

exports.default = Vector;


//////////////////
// WEBPACK FOOTER
// ./src/common/maths/geometry/Vector.js
// module id = 323
// module chunks = 0